<template>
  <div class="service" v-if="getThird">
    <div class="service-content">
      <div class="service-title">服务市场</div>
      <div class="service-info">
        <div
          class="service-item flex-direction-column"
          v-for="(item, index) in getThird.value"
          :key="index"
        >
          <div class="title">{{ item.openTitle }}</div>
          <div class="service-des">{{ item.openDes }}</div>
          <div class="btn-panel">
            <div class="service-btn">
              <router-link tag="a" target="_blank" :to="item.openLink">
                <a :href="item.openLink" target="_blank">查看详情</a>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      getThird: "home/getThird"
    })
  }
};
</script>

<style lang="less" scoped>
.service {
  display: flex;
  align-content: center;
  align-items: center;
  flex-direction: column;
  height: 672px;
  background: @color-default;
  color: @color-font-white;
  background-image: url("../../../assets/images/service.png");
  background-size: 100% 100%;
  font-size: 14px;
  .service-content {
    width: 1200px;
    .service-title {
      font-size: 36px;
      margin: 90px 0px;
      text-align: center;
    }
    .service-info {
      display: flex;
      background-color: rgba(0, 0, 0, 0.6);
      height: 366px;
      .service-item {
        min-width: 25%;
        height: 366px;
        cursor: pointer;
        padding: 60px 45px 32px 45px;
      }
      .service-item:hover .service-btn {
        display: block;
      }
      .service-item:hover {
        background: @color-primary;
      }
      .title {
        font-size: 24px;
        margin-bottom: 34px;
        text-align: center;
      }
      .btn-panel {
        width: 100%;
      }
      .service-des {
        flex: 1;
      }
      .service-btn {
        float: right;
        width: 96px;
        height: 32px;
        line-height: 32px;
        background: @color-font-white;
        border-radius: 2px;
        color: @color-primary;
        text-align: center;
        display: none;
      }
    }
  }
}
</style>
